// extracted by mini-css-extract-plugin
export default {"cta":"loginCta_cta__d+APo"};